
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projekte",
      function () {
        return require("private-next-pages/projekte/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projekte"])
      });
    }
  